const STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403
};

export { STATUS_CODES };
